export function parseDomainUrl(value: unknown): string | undefined {
  if (typeof value === 'string') {
    const normalized = value.startsWith('http') ? value : `https://${value}`
    try {
      return new URL(normalized).toString().replace(/\/$/, '')
    } catch {
      return undefined
    }
  }

  if (!value || typeof value !== 'object') return undefined
  const record = value as Record<string, unknown>
  return parseDomainUrl(record.domain)
}
